"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusAwareFetch = statusAwareFetch;
exports.default = void 0;

var _network = require("@adobe/exc-app/network");

var _invalidStatusCodeError = _interopRequireDefault(require("./invalidStatusCodeError"));

var _Level = require("@adobe/exc-app/metrics/Level");

var _metrics = _interopRequireDefault(require("../metrics"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const fetchConfig = {
  appId: '',
  getTokenInfo: () => Promise.reject('Api called without token'),
  imsClientId: '',
  imsOrg: '',
  sandbox: {
    isDefault: true,
    name: '',
    region: '',
    type: ''
  }
};

const logger = _metrics.default.create('exc.module-runtime.network.fetch');

function configure(config) {
  Object.assign(fetchConfig, config);
}

function setAuth(init, metadata) {
  init.headers.set('Authorization', `Bearer ${metadata.token}`);
  metadata.imsClientId && init.headers.set('x-api-key', metadata.imsClientId);
}

function setImsOrg(init, metadata) {
  setAuth(init, metadata);
  metadata.imsOrg && init.headers.set('x-gw-ims-org-id', metadata.imsOrg);
}

function setSandbox(init, metadata) {
  setImsOrg(init, metadata);

  if (init.auth === 'Header') {
    metadata.sandbox && init.headers.set('x-sandbox-name', metadata.sandbox.name);
  }
}

function setSandboxPlus(init, metadata) {
  setSandbox(init, metadata);

  if (init.auth === 'Header') {
    metadata.sandbox && init.headers.set('x-sandbox-type', metadata.sandbox.type);
    metadata.sandbox && init.headers.set('x-sandbox-default', metadata.sandbox.isDefault.toString());
  }
}

function addHeadersBasedOnScope(init, metadata) {
  if (init && init.scope) {
    switch (init.scope) {
      case _network.FetchScope.AUTH:
        setAuth(init, metadata);
        return;

      case _network.FetchScope.ORG:
        setImsOrg(init, metadata);
        return;

      case _network.FetchScope.SANDBOX:
        setSandbox(init, metadata);
        return;

      case _network.FetchScope.SANDBOX_PLUS:
        setSandboxPlus(init, metadata);
        return;

      case _network.FetchScope.NONE:
        return;

      default:
        return;
    }
  }
}

function updateReq(input, init) {
  return fetchConfig.getTokenInfo().then(({
    token
  }) => {
    if (init && (init.auth || init.scope && init.scope !== _network.FetchScope.NONE)) {
      const {
        imsClientId,
        imsOrg,
        sandbox
      } = fetchConfig;
      let metadata = {
        imsClientId,
        imsOrg,
        sandbox,
        token
      };
      init.metadata && Object.assign(metadata, init.metadata);

      if (!(init.headers instanceof Headers)) {
        init.headers = new Headers(init.headers);
      }

      init.scope = init.scope || _network.FetchScope.SANDBOX_PLUS;
      addHeadersBasedOnScope(init, metadata);

      if (init.auth === 'Body') {
        const params = {};
        const {
          sandbox: metaDataSandbox
        } = metadata;

        if (metaDataSandbox && [_network.FetchScope.SANDBOX_PLUS, _network.FetchScope.SANDBOX].includes(init.scope)) {
          params.sandboxName = metaDataSandbox.name;

          if (init.scope === _network.FetchScope.SANDBOX_PLUS) {
            params.sandboxType = metaDataSandbox.type;
            params.isDefaultSandbox = metaDataSandbox.isDefault.toString();
          }
        }

        if (!init.body) {
          init.body = JSON.stringify(params);
        } else {
          let parsedBody = JSON.parse(init.body);
          Object.assign(parsedBody, params);
          init.body = JSON.stringify(parsedBody);
        }
      }
    }

    return {
      init,
      input
    };
  });
}

async function statusAwareFetch(input, init) {
  const {
    statusCodesToRetry = []
  } = init;
  const response = await fetch(input, init); // Only check status codes to retry if response is not ok.

  if (!response.ok && statusCodesToRetry.includes(response.status)) {
    throw new _invalidStatusCodeError.default(`${response.status} ${response.statusText}`, response);
  }

  return response;
}

function fetchApi(fetchInput, fetchInit, ioEndpoint, ioRegionSpecificMap) {
  return updateReq(fetchInput, fetchInit).then(async ({
    init,
    input
  }) => {
    //populate network-runtime option to differentiate network runtime fetch.
    const startTimestamp = Date.now();

    try {
      if (ioRegionSpecificMap && fetchConfig.sandbox && fetchConfig.sandbox.region && ioRegionSpecificMap[fetchConfig.sandbox.region.toLowerCase()]) {
        let ioRegionSpecificEndpoint = ioRegionSpecificMap[fetchConfig.sandbox.region.toLowerCase()];
        ioRegionSpecificEndpoint = `${ioRegionSpecificEndpoint}/graph/graphql?appId=${fetchConfig.appId}`;
        input = input instanceof Request ? new Request(ioRegionSpecificEndpoint, input) : ioRegionSpecificEndpoint;
      } // Run a slightly modified version of fetch which throws for certain status codes
      // By default throw on 429, 502, etc. - Could be configured for different codes via init.


      return await statusAwareFetch(input, Object.assign({}, init, {
        'network-runtime': true
      }));
    } catch (error) {
      // Note: We have disabled the fallback to the ioEndpoint here, and may re-enable
      // after gathering more data.
      const addedInfo = error instanceof _invalidStatusCodeError.default ? ` with status ${error.status}` : '';
      logger.event('Fetch.fallback', `Initial call failed${addedInfo}. Retrying with exponential backoff.`, {
        endpoint: input instanceof Request ? input.url : input,
        ioEndpoint
      }, {
        level: _Level.Level.WARN
      }); // Since fetchWithRetry will (hopefully) not be required for most fetches,
      // dynamically import it to save bytes.

      const {
        fetchWithRetry
      } = await Promise.resolve().then(() => _interopRequireWildcard(require('./fetchRetry')));
      return await fetchWithRetry(ioEndpoint || input, init, error, startTimestamp);
    }
  }).catch(err => {
    if (ioEndpoint) {
      logger.event('Fetch.fallbackFailed', 'Failed to call both Primary and Secondary domain', {
        endpoint: fetchInput instanceof Request ? fetchInput.url : fetchInput,
        ioEndpoint
      }, {
        level: _Level.Level.ERROR
      });
    }

    if (err instanceof _invalidStatusCodeError.default) {
      throw err;
    }

    throw new Error(`error in making a fetch call. Error is:- ${err}`);
  });
}

var _default = {
  configure,
  fetch: fetchApi,
  updateReq
};
exports.default = _default;